import { HgSupportedLanguage } from '@smg-real-estate/domus';

/** Locale-specific agency directory home route name (e.g. home-de). */
export function getHomeRouteName(locale: string): string {
  return `home-${locale}`;
}

export const generateAgencyProfilePagePath = (
  language: HgSupportedLanguage,
  agencyUrlKeyword: string,
  agencyId: string,
): string => {
  const agencyProfilePageRoutes: Record<HgSupportedLanguage, string> = {
    [HgSupportedLanguage.DE]: 'anbieter',
    [HgSupportedLanguage.EN]: 'agency',
    [HgSupportedLanguage.FR]: 'regie',
    [HgSupportedLanguage.IT]: 'agenzia',
  };

  return `${import.meta.env.VUE_APP_BASE_URL}/${agencyProfilePageRoutes[language]}/${agencyId}/${agencyUrlKeyword}`;
};
